/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2024] Narbase Technologies
 * All Rights Reserved.
 * Created by shalaga44
 * On: 19/Aug/2024.
 */

package com.narbase.letsgo.common

import com.narbase.letsgo.web.routing.domain.appSettings.Platform
import com.narbase.letsgo.web.routing.domain.appSettings.WebPlatform
import kotlinx.browser.window
import org.w3c.dom.get

actual val isDev: Boolean
    get() {
        return window.localStorage[IS_DEV_KEY]?.ifBlank { null }?.toBoolean() ?: false
    }
actual val isMobileDev: Boolean
    get() {
        return when(platform){
            Platform.iOS, Platform.Android -> isDev
            Platform.Web -> window.localStorage[IS_MOBILE_DEV_KEY]?.ifBlank { null }?.toBoolean() ?: false
        }

    }

// todo: consistent set conditions (hostname or origin)
actual val isStaging: Boolean
    get() {
        return window.location.hostname.contains(("staging.narbase.com:4567"))
    }

val isProd: Boolean
    get() {
        return (
                window.location.origin == "https://car.narbase.com" ||
                        window.location.origin == "https://car.narbase.com"
                )
    }

fun getUserAgent(): String {
    return window.navigator.userAgent
}

val isMobileWeb by lazy {
    /*if (isMobile) false
    else*/ when (webPlatform) {
        WebPlatform.iOS, WebPlatform.Android -> true
        WebPlatform.Desktop -> false
    }
}
val webPlatform by lazy {
    when {
        isIosWeb -> WebPlatform.iOS
        isAndroidWeb -> WebPlatform.Android
        isDesktopWeb -> WebPlatform.Desktop
        else -> WebPlatform.Desktop
    }
}
val isIosWeb = WebPlatform.isIOS(getUserAgent())
val isAndroidWeb = WebPlatform.isAndroid(getUserAgent())
val isDesktopWeb get() = !WebPlatform.isIOS(getUserAgent()) && !(WebPlatform.isAndroid(getUserAgent()))

